import { createContext, useMemo } from 'react'

import { useContextWithCheck } from 'hooks'
import { AppApiBase } from 'api/core/AppApiBase'

import { AppApiContextProps, AppApiProviderProps } from './index'

const AppApiContext = createContext<AppApiContextProps | undefined>(undefined)

export const AppApiProvider = ({
  children,
  baseURL,
  platform,
  brand,
}: AppApiProviderProps): JSX.Element => {
  const apiInstance = useMemo(
    () =>
      new AppApiBase({
        baseURL,
        brand,
        platform,
      }),
    [baseURL, brand, platform],
  )

  return (
    <AppApiContext.Provider
      value={{
        apiInstance,
      }}
    >
      {children}
    </AppApiContext.Provider>
  )
}

export const useAppApiContext = () => useContextWithCheck(AppApiContext)

/**
 * Creates the instance of provided ApiService using props from context
 */
export function useAppApi<T>(ApiService: new (api: AppApiBase) => T): T {
  const { apiInstance } = useContextWithCheck(AppApiContext)
  return useMemo(() => new ApiService(apiInstance), [ApiService, apiInstance])
}
